<template>
   <div class="content">
     <div class="tit">邀请码生成器</div>
     <div class="boxall">
       <img src="../../assets/img/bgcode.png" alt="" class="bgcode">
       <div class="boxcenter">
        <div class="leftbox">
          <div class="topbox">
           <div class="lineone">
            <span class="name"> 手机号：</span>
             <input type="text" placeholder="请输入手机号码" class="nameinput" v-model="phone" maxlength="11">
           </div>
            <div class="lineone" style="margin-top:12px">
              <span class="name">等级：</span>
              <span v-for="(item,index) in list3" :key="index" :class="choosen3==index?'blue':'gery'" @click="identy(item.id,item.code)">{{item.state}}</span>
            </div>
          </div>
          <div class="bottom_btn" @click="generate">
            生成二维码
          </div>
        </div>
       <div class="rightbox">
         <div class="righttop">
           <div class="imgbox" v-if="image!=''"><img :src="image" alt="" class="codeimg"></div>
          <div class="word" v-else>此处生成二维码</div>

         </div>
<!--         <div class="right_btn" v-if="image!=''">-->
         <div class="right_btn" @click="clone">
           保存图片
         </div>
       </div>
       </div>
     </div>
   </div>
</template>

<script>
import {Toast} from "vant";
import {getcodema} from "api/ajax";
import axios from 'axios'
import {clos_encryptDes, clos_encryptDes1} from "@/encryption";
import html2canvas from 'html2canvas';
export default {
name: "Invitationcode",
  data(){
    return{
      phone:'',
      list3:[{state:'跳首页',id:0,code:''},{state:'购房会员',id:1,code:3},{state:'权益会员',id:2,code:4}],
      // list3:[{state:'购房会员',id:0,code:3},{state:'权益会员',id:1,code:4},{state:'创业合伙人',id:2,code:2},{state:'区域运营中心',id:3,code:1}],
      choosen3:0,
      image:'',
      memberLevel:''
    }
  },
  methods:{
    identy(e,f){
      this.choosen3=e
      this.memberLevel=f
    },
    clone(){
      var alink = document.createElement("a");
      alink.href = this.image;
      alink.download = "images.png"; //图片名
      alink.click();
    },

    arrayBufferToBase64 (buffer) {
      var binary = ''
      var bytes = new Uint8Array(buffer)
      var len = bytes.byteLength
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    },
    async generate(){
      if(this.phone==''){
        // Toast.fail('电话不能为空');
        Toast('电话不能为空');
        // this.$Message.warning("电话不能为空")
        return false
      }
      let time = this.time()
      let action = "merchants.getQRCode";
      let args = {
        action: "merchants.getQRCode",
        phone:this.phone,//电话
        memberLevel:this.memberLevel,
        timestamp:time,
        accessKeyId:"APId1482c4fc9",
        signature:clos_encryptDes1(action,time)
      };
      axios({
            method:'post',
            url:'https://www.fangpinyouxuan.com/backEnd/api/dispatcher',
            // url:'http://192.168.8.37:8082/api/dispatcher',
            // responseType: 'blob',
            responseType: 'arraybuffer', // 最为关键
            headers:{'auth-token':this.token},
            data:args
          },
          // headers:'auth-token':this.token
          // config.headers['auth-token'] = getToken()
      ).then(response=>{
          // let stle = window.URL.createObjectURL(response)//这里也是关键,调用window的这个方法URL方法
          this.image ='data:image/jpeg;base64,' + this.arrayBufferToBase64(response.data)
        // 'data:image/jpeg;base64,' + that.arrayBufferToBase64(response.data)
        console.log(this.arrayBufferToBase64(response.data),'我的图片')
      })

    }
    }
}
</script>

<style lang="scss" scoped>
  .content{
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    //font-size: 4px;
    .tit{
      height:23px;
      font-size: 8px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #444444;
      line-height: 23px;
      margin-left: 8px;
    }
    .boxall{
      position: relative;
      .bgcode{
        width: 100%;
      }
      .boxcenter{
        position: absolute;
        margin: 0 auto;
        left: 23%;
        top:20%;
        display: flex;
        justify-content: space-between;
        .leftbox{
          .topbox{
            width: 130px;
            height: 26px;
            background: #FFFFFF;
            padding: 5px 4px;
            .lineone{
              height: 11.5px;
              line-height: 11.5px;
              .name{
              font-size:4px ;
                display: inline-block;
                width: 18px;
                text-align: right;
              }
              .nameinput{
                border: none;
                width: 70%;
                border-bottom: 1px dashed #cccccc;
                font-size: 3.5px;
              }

              .blue{
                background-color:#0081ff;
                padding: 1.25px 4px;
                color: white;
                font-size: 3.5px;
                border-radius: 3px;
                height: 5px;
                line-height: 5px;
                margin-right: 3px;
              }
              .gery{
                background-color:white;
                border: 1px solid #cccccc;
                padding:1.25px 4px;
                color: #cccccc;
                font-size:3.5px;
                border-radius: 3px;
                height:5px;
                line-height: 5px;
                margin-right: 3px;
              }
            }
          }
          .bottom_btn{
            width: 40px;
            height: 15px;
            line-height: 15px;
            text-align: center;
            background: #348DFF;
            border-radius: 1.6px;
            color: white;
            margin: 6px auto;
            font-size: 4px;
          }
        }
        .rightbox{
          margin-left:8px;
          .righttop{
            position: relative;
            width: 60px;
            height: 60px;
            background: #FFFFFF;
            border: 1px solid #E2E2E2;
            .word{
              color: #9E9E9E;
              font-size: 4px;
              margin: 25px auto;
              text-align: center;
            }
            .imgbox{
              //position: absolute;
              //left: 5.5px ;
              //top: 5.5px;
              width: 50px;
              margin: 4px auto 0;
              .codeimg{
               //position: absolute;
                width: 50px;
                margin: 0 auto;

              }
            }
          }
        .right_btn{
          width: 60px;
          height: 11px;
          line-height: 11px;
          background: #348DFF;
          border-radius: 1.5px;
          color: white;
          text-align: center;
          font-size:4px;
          margin-top: 3px;
        }
        }
      }

    }
  }
</style>
